<template>
  <div class="pa-50">
    <div v-if="loading">
      Carregando...
    </div>
    <div v-else>
      <section class="hero is-medium is-info is-bold" v-if="verified">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              Verificação de conta!
            </h1>
            <h2 class="subtitle">
              Seu email foi verificado com sucesso. Agora você pode efetuar o login e acessar sua conta!
            </h2>
          </div>
        </div>
      </section>
      <section class="hero is-medium is-danger is-bold" v-else>
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              Verificação de conta!
            </h1>
            <h2 class="subtitle">
              Não foi possível confirmar a conta, link expirado, solice uma nova confirmação de conta <a href="#">aqui</a>
            </h2>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>

<script>
import { http } from '@/support/http/http'
export default {
  name: 'Verify',
  data: () => ({
    verified: false,
    loading: true
  }),
  mounted () {
    this.verifyAccount(this.$route.params.token)
  },
  methods: {
    verifyAccount (token) {
      http.get(`/verify/${token}`)
        .then(() => {
          this.verified = true
        })
        .catch(() => {
          this.verified = false
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.pa-50 {
  padding: 50px;
}
</style>
